<template>
  <div class="container" id="bot">
    <h1 class="section_title" v-if="custom.title">Example</h1>

      <div class="flex w-full">

        <div class="bot_container border relative flex flex-col">
            <div class="w-full py-3 px-4 font-bold bg-gray-100 shadow-xl bot_title">
              <div class="er_logo"></div>
               <span style="font-size: 14px; padding: 4px 10px; border-radius: 5px; background: orangered; color: white; font-weight: 100">ChatBot</span>
            </div>
            <div class="w-full messages pt-4" v-chat-scroll="{always: true, smooth: true, scrollonremoved:true}">
              <div v-for="(message, index) in bot" :key="index">
                <div class="bot_entry" v-if="message.id === 'location_ip'">
                  <div class="bot_message" v-html="message.text"></div>
                  <div class="bot_message" v-if="location.country">
                       <p>{{location.region}}, {{location.country_name}}</p>
                  </div>
                  <div class="bot_options">
                    <div class="option">
                      <div @click="pushInstance(message.next, 0)" class="px-3">Yes</div>
                    </div>
                    <div class="option">
                      <div class="px-3" @click="pushInstance(message.reject, 500)">No</div>
                    </div>
                  </div>
                </div>
                
                <div v-else class="bot_entry" :class="{user: message.from == 'human'}" >
                  <div class="bot_message" v-html="message.text" :class="{header: setPadding(message.text)}"></div>
                  <div class="bot_thinking" v-if="thinking == message.id && index == bot.length-1">
                    <div class="pulse-bubble pulse-bubble-1"></div>
                    <div class="pulse-bubble pulse-bubble-2"></div>
                    <div class="pulse-bubble pulse-bubble-3"></div>
                  </div>
                  <div v-if="message.options" class="bot_options">
                    <div v-for="(option, index) in message.options" v-show="options.includes(message.id)" class="option" :key="index">
                      <div @click="pushInstance(option.id)">{{option.text}}</div>
                    </div>
                  </div>
             
                </div>
              </div>


            </div>
            <div class="input_container w-full">

                       <div v-if="getInstance(currentInstance).input == 'single'" class="w-full">
                      <input ref="answer" :placeholder="placeholder" v-on:keyup.enter="handleSubmit" v-model='test' />

                  </div>
            </div>
        </div>

        <div class="json_container">
          <div class="header">
              <p @click="showJson = 'current'" :class="{active: showJson == 'current'}">Current Instance</p>
              <p @click="showJson = 'all'" :class="{active: showJson == 'all'}">All Instances</p>
          </div>

        <pre v-if="showJson == 'current'">{{getInstance(currentInstance)}}</pre>
        <pre v-if="showJson == 'all'">{{config.instances}}</pre>

      </div>

      </div>

</div>
</template>

<script>
import axios from "axios";

export default {
  props: ["custom", "html"],
  components: {
  },
  data () {
    return {
      value: '',
      active: null,
      thinking: false,
      placeholder: 'enter your response',
      options: [],
      user: [],
      showJson: 'all',
      stream: '',
      test: '',
      setText: false,
      src: null,
      videoData: null,
      send_video: false,
      recording: false,
      videoComplete: false,
      modal: false,
      bot: [],
      currentInstance: null,
      gettingLocation: false,
      errorStr: null,
      location: null,
      config: {
        commands: [
          {
            "command": "new account",
            "next": "create_account"
          },
          {
            "command": "share",
            "next": "share_story"
          }
        ],
        instances: [
          {
            "id": "welcome",
            "start": "true",
            "text": "<header>Hi, I'm Alice..</header><statement>the Edgeryders assistant. What would you like to ask?</statement>",
            "confirm": "Thanks.",
            "options": [{"id": "about_edgeryders", "text": "What is Edgeryders?"}, {"id": "create_account", "text": "I want to sign up"}]
          },
          {
            "id": "about_edgeryders",
            "text": "<header>About Edgeryders</header><statement>Edgeryders is a community of 4000 members from across the world. You can find out what's happening <a href='https://start.edgeryders.eu' target='_blank'>here</a>.</statement>",
            "auto": true,
            "next": "help"
          },
          {
            "id": "help",
            "text": "What else would you like to ask?",
            "options": [{"id": "tell_joke", "text": "Tell me a joke"}, {"id": "about_bot", "text": "What's with the name?"}]
          },
          {
            "id": "about_bot",
            "text": "My name is a tribute to A.L.I.C.E, a natural language processing chatterbot by  <a href='https://en.wikipedia.org/wiki/Richard_Wallace_(scientist)' target='_blank'>Richard Wallace</a>. One of the goals of Edgeryders Alice is to write a modern interpreter of <a href='https://en.wikipedia.org/wiki/AIML' target='_blank'>AIML</a>, the syntax originaly used by Wallace for specifying heuristic conversation rules. It's also a pretty cool name.",
            "delay": 4000,
            "auto": true,
            "next": "help"
          },
          {
            "id": "tell_joke",
            "command": "fetch_joke",
            "delay": 4000,
            "confirm": "🤖",
            "next": "help"
          },
          {
            "id": "create_account",
            "text": "<header>Create an account</header><statement>An Edgeryders account is free and gives you access to: <ul><li>👥 A community of over 5000 members</li><li>🎓 Free online courses & webinars</li><li>🛠 Tools for remote work</li><li>📝 Help setting up your own projects</li></ul></statement>",
            "auto": true,
            "next": "set_username"
          },
          {
            "id": "set_username",
            "text": "first, what <b>username</b> would you like?",
            "input": "single",
            "placeholder": "enter your username",
            "confirm": "thanks",
            "next": "set_email"
          },
          {
            "id": "set_email",
            "text": "what is your email address?",
            "placeholder": "enter your email address",
            "input": "single",
            "next": "location_ip"
          },
          {
            "id": "location_ip",
            "text": "can we set this as your location? <small>this is optional and allows us to connect you with other members in your region.</small>",
            "confirm": "Thanks.",
            "next": "confirm_account",
            "reject": "confirm_account",
          },
          {
            "id": "confirm_account",
            "text": "<header>Check your inbox</header><statement>That's it! All you need to do now is check your inbox for a verification email containing your username and password.</statement>",
            "next": "help",
            "auto": true,
            "delay": 3500
          }
        ]
      }
    }
  },
  methods: {
    search(input) {
      if (input.length < 1) { return [] }
      else if (input.includes('/')) {
        return this.config.commands.filter(entry => {
          return entry.command.toLowerCase()
            .startsWith(input.substr(1).toLowerCase())
        })
       } else {
          this.test = input;
       }
    },
    sendMessage(value) {
      var obj = {};
      obj['text'] = value;
      obj['from'] = 'human';
      this.bot.push(obj);
      var instance = this.getInstance(this.currentInstance);
      this.confirm(instance)
    },
   toggleModal() {
      this.modal = !this.modal;
    this.video = this.$refs.video;
    if(navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        navigator.mediaDevices.getUserMedia({ video: true }).then(stream => {
            this.$refs.video.srcObject = stream;
            this.video.play();
        });
    }
    },
    getResultValue(result) {
      this.test = result
    },
    getInstance(id) {
      return this.config.instances.filter(x => x.id === id)[0]
    },
    handleSubmit() {
        this.sendMessage(this.test);
        this.test = ''
    },
    pushInstance(id, delay) {
      var instance = this.getInstance(id);
      this.currentInstance = id;
      if (!instance.command) {
        setTimeout(() => this.bot.push(instance), delay);
      }
      
      if (instance.options) {
        this.showOptions(id, 1000);
      }
      if (instance.auto) {
        this.deepThink(id, 4500);
        setTimeout(() => this.pushInstance(instance.next), instance.delay || 1000)
      }
      if (instance.command) {
        var command = instance.command;
        this[command]();
        this.confirm(instance, 4000, 6000);
      }
      if (instance.input == 'single') {
        this.placeholder = instance.placeholder;
        this.$nextTick(() => this.$refs.answer.focus());
      }
    },
    fetch_joke(){
      axios.get("https://icanhazdadjoke.com/", { headers: { "Accept": "text/plain" }}).then(({ data }) => {
        var obj = {};
        obj['text'] = data;
        this.bot.push(obj);
      });
    },
    setPadding(string) {
      if (string && string.includes('<header>' || '<statement>')) {
        return true
      } else {
        return false
      }
    },
    deepThink(id, delay) {
      setTimeout(() => this.thinking = id, 400)
      setTimeout(() => this.thinking = null, delay)
    },
    showOptions(id, delay) {
      setTimeout(() => this.options.push(id), delay)
    },
    confirm(instance, delayMessage, delayNext) {
      if (instance.confirm) {
        var obj = {};
        obj['text'] = instance.confirm;
        setTimeout(() =>  this.bot.push(obj), delayMessage || 800)
      }
        this.pushInstance(instance.next, delayNext || 1800)
    },
    reject(instance) {
        this.pushInstance(instance.reject, 1800)
    },
    async getLocation() {
      
      return new Promise((resolve, reject) => {

        if(!("geolocation" in navigator)) {
          reject(new Error('Geolocation is not available.'));
        }

        navigator.geolocation.getCurrentPosition(pos => {
          resolve(pos);
        }, err => {
          reject(err);
        });

      });
    },
    async locateMe() {

      this.gettingLocation = true;
      try {
        this.gettingLocation = false;
        this.location = await this.getLocation();
      } catch(e) {
        this.gettingLocation = false;
        this.errorStr = e.message;
      }
      
    }
  },
  created() {
    this.pushInstance('welcome');

    axios.get("https://ipapi.co/json/").then(({ data }) => {
        this.location = data;
     
        

      });
  }
};
</script>
<style lang="scss" scoped>
.container {
  max-width: 80%;
  @apply mx-auto mt-10 pb-10;
}

.bot_container {
  @apply border;
  flex-basis: 500px;
  flex-shrink: 0;
  min-height: 400px;
  height: 500px;
  border-radius: 10px;
  overflow: hidden;
 scroll-behavior: smooth;
}

  .messages {
  overflow: scroll;
  flex-grow: 1;
padding: 15px;
}
.bot_title {
@apply flex items-center text-xl border-b;
height: 60px;
flex-shrink: 0;
color: orangered;
background: linear-gradient(180deg,hsla(0,0%,92.9%,.6),#fff),#fff;
box-shadow: 0 2px 20px rgba(0,0,0,0.06);
background-size: 100%;
  .er_logo {
  @apply mr-3;
    background: url("data:image/svg+xml;charset=utf-8,%3Csvg viewBox='0 0 500 500' version='1' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill='%23ff4500' d='M0 250a250 250 0 11500 0 250 250 0 01-500 0zm250 183V250H67a183 183 0 11183 183z' fill-rule='evenodd'/%3E%3C/svg%3E") no-repeat 0 center;
  background-size: 25px;
  width: 37px;
  height: 40px;
  border-right: 1px solid #ddd;
}
}
.input_container {
  max-height: 400px;
  transition: all 1s ease;
  input {
  width: 100%;
    @apply border-t;

  padding: 12px 20px;
  font-size: 16px;
}
}

.bot_message {
  @apply rounded-lg border p-3 py-2 mb-2 overflow-hidden;
  font-size: 14px;
  opacity:0;
   animation: slide_up .4s ease forwards .3s;
  
      font-weight: 100;
display: inline-block;
  width: auto;
max-width: 60%;
  &.header {
  @apply p-0 ;
 flex-basis: 65%;
 min-width: 65%;
}
  /deep/ header {
    @apply mx-auto p-2 px-4 bg-gray-100 font-bold border-b;
    color: orangered;
    width: 100%;
  }
   /deep/ small {
    @apply w-full block border-t mt-1 pt-1 pb-1;
  }
   /deep/ b {
    @apply font-bold;
  }
  /deep/ a {
    @apply font-bold underline;
  }
  /deep/ statement {
    @apply p-2 mx-auto bg-gray-100;
    color: black;
    width: 95%;
    display: block;
    background: white;
    li {
    @apply py-2 border-b;
    &:last-child {
    border: none;
  }
  }
      ul {
      @apply pt-1;
    }
  }
}

@keyframes slide_up {
  0% { 
    transform: translateY(10px); 
    opacity: 0; 
  }
  100% { 
    transform: translateY(0px); 
    opacity: 1; 
  }
}

.bot_entry {
  @apply flex flex-col items-start;
  &.user {
  @apply items-end;
}
  }

.bot_options {
  @apply float-right text-right mt-1;
  width: 100%;
  min-height: 50px;
  text-align: right;
  .option {
  @apply mr-2 font-bold;
    animation: slide_up .4s ease forwards;
    opacity: 0;
    &:last-child {
       @apply mr-0;
  }
  &:hover {
  background: orangered;
  border: 1px solid orangered;
  color: white;
  cursor: pointer;
}
  }
}

@for $i from 1 to 10 {
  .bot_options div:nth-child(#{$i}) { animation-delay: $i * 0.12s !important; }
}

.option {
  @apply inline-block border rounded-lg p-2 mb-2;
  width: auto;
  font-size: 13px;
  font-weight: 400;
}

.input {
  width: 100%;
  /deep/ input {
  width: 100%;
  @apply p-4;
}
}



.bot_thinking {
  width: 120px;
  @apply mx-2 py-4;
}

.pulse-bubble {
  width:7px;
  height: 7px;
  @apply mr-1 float-left;
  border-radius: 50%;
  background-color: #ddd;
}
@keyframes pulse {
  from {
    opacity: 1;
    transform: scale(1);
  }
  to {
    opacity: .25;
    transform: scale(.75);
  }
}
.pulse-bubble-1 {
    animation: pulse .4s ease 0s infinite alternate;
}
.pulse-bubble-2 {
    animation: pulse .4s ease .2s infinite alternate;
}
.pulse-bubble-3 {
    animation: pulse .4s ease .4s infinite alternate;
}

.json_container {
  @apply ml-4 flex flex-col rounded-lg border overflow-hidden;
  flex-grow: 1;
  width: 30%;
  margin-left: 5%;
  height: 500px;

  background: #fafafa;
pre {
  padding: 20px;
  flex-grow: 1;
    overflow: scroll;
  font-size: 14px;
  white-space: pre-wrap;       /* css-3 */
 white-space: -moz-pre-wrap;  /* Mozilla, since 1999 */
 white-space: -pre-wrap;      /* Opera 4-6 */
 white-space: -o-pre-wrap;    /* Opera 7 */
 word-wrap: break-word;  
}
.header {
  @apply flex border-b;
  height: 60px;
  width: 100%;
  flex-shrink: 0;
  p {
    @apply h-full border-r flex items-center px-4 font-bold text-sm;
    background: rgba(255,255,255,0.2);
    &:hover {
    cursor: pointer;
    }
    &.active {
      background: rgba(0,0,0,0.02);
    }
  }
}
}

</style>
